import { GET_ASSETS_REQUEST, GET_ASSETS_SUCCESS, GET_ASSETS_ERROR } from "../ActionTypes/ActionTypes.js";

const initialState = {
  assetLoading: false,
  assetsData: null,
  assetStatus: null,
  error: null,
};

const assetsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ASSETS_REQUEST:
      return { ...state, assetLoading: true, error: null };

    case GET_ASSETS_SUCCESS:
      return { ...state, assetLoading: false, assetsData: action.payload, assetStatus: true };

    case GET_ASSETS_ERROR:
      return { ...state, assetLoading: false, error: action.payload, assetStatus: false };

    default:
      return state;
  }
};

export default assetsReducer;
